<template>
  <div>


    <v-card outlined
             class="mb-4"
             color="#488ba6"
             dark
    >
      <div v-if="state.payment.response.code === '1' || state.payment.response.text === 'Comped Transaction was a Success.'">

        <v-card-title class="headline">{{ state.payment.response.text }}
        </v-card-title>

        <v-card-subtitle v-if="state.payment.response.master">Registration Name:
          {{ state.payment.response.master.first_name }} {{ state.payment.response.master.last_name }}
        </v-card-subtitle>
        <v-card-text>
          <p>
              You are now registered for the 2026 FVS Annual Meeting! Please check your email for your transaction
            receipt.
          </p>
        </v-card-text>
        <ReviewTable :form-total="formTotal.display"></ReviewTable>
        <v-card-text>
          <p>Card Ending In: {{ state.payment.cc.number.substr(state.payment.cc.number.length - 4) }}</p>
          <p>Card Name: {{ state.payment.cc.firstName }} {{ state.payment.cc.lastName }}</p>
          <p>Receipt Sent to: {{ state.payment.response.receiptTo }}</p>
        </v-card-text>
      </div>
      <div v-else-if="state.payment.response.errorMsg">
        <v-card-title class="headline">The transaction was not successful.
        </v-card-title>
        <v-card-subtitle>{{ state.payment.response.errorMsg }}
        </v-card-subtitle>
        <v-card-text>
          <p>If you need assistance please contact debug@fvs.org</p>
        </v-card-text>
      </div>
      <div v-else>
        <v-card-title class="headline">There was an unknown error with your transaction.
        </v-card-title>

        <v-card-text>
          <p>Your transaction encountered an unknown error, please contact the FVS main phone line at 904-309-6268 or email
            <a style="color:white" href="mailto:debug@fvs.org">debug@fvs.org</a>.</p>
        </v-card-text>
      </div>

    </v-card>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import ReviewTable from './ReviewTable'


export default {
  name: "Success",
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
  },
  components: {
    ReviewTable
  },
  props: [
    'formTotal'
  ],
}
</script>

<style scoped>

</style>